/**
 * Created by liubaorui on 22/11/14.
 * @desc 拼音码使用简化版配置
 */

export default {
  // 物资拼音码配置(全部)
  varNo: {
    url: '/api/blade-vardict/vardict/searchCode',    // 请求地址
    value: 'varNo',    // 唯一值
    label: 'varName',    // 显示名称
    soleValue: 'varNo',    // 存储给后台的字段名称
  },
  // 销售物资拼音码
  varNo0: {
    url: '/api/blade-vardict/vardict/searchCode',
    value: 'varNo',
    label: 'varName',
    soleValue: 'varNo',
    customQuery: {
      varType: 0
    }
  },
  // 采购物资拼音码
  varNo1: {
    url: '/api/blade-vardict/vardict/searchCode',
    value: 'varNo',
    label: 'varName',
    soleValue: 'varNo',
    customQuery: {
      varType: 1
    }
  },
  // 客户/供应商 拼音码
  custNo: {
    url: '/api/blade-custInfo/custInfo/searchCode',
    value: 'custNo',
    label: 'custName',
    soleValue: 'custNo',
  },
  // 销售客户拼音码（结算单位）
  balanceCustNo: {
    url: '/api/blade-custInfo/custInfo/searchCode',
    value: 'custNo',
    label: 'custName',
    soleValue: 'balanceCustNo',
    customQuery: {
      custType: 0
    }
  },
  // 销售客户拼音码（收货单位）
  receiveCustNo: {
    url: '/api/blade-custInfo/custInfo/searchCode',
    value: 'custNo',
    label: 'custName',
    soleValue: 'receiveCustNo',
    customQuery: {
      custType: 0
    }
  },
  // 采购供应商拼音码
  custNo1: {
    url: '/api/blade-custInfo/custInfo/searchCode',
    value: 'custNo',
    label: 'custName',
    soleValue: 'custNo',
    customQuery: {
      custType: 1
    }
  },
  // 客户或供应商拼音码
  custNo2: {
    url: '/api/blade-custInfo/custInfo/searchCode',
    value: 'custNo',
    label: 'custName',
    soleValue: 'custNo',
    customQuery: {
      custType: 2
    }
  },

  // 主车号拼音码配置
  vehicleNo: {
    url: '/api/blade-vehicle/vehicle/searchCode',
    value: 'vehicleNo',
    label: 'vehicleNo',
    soleValue: 'vehicleNo'
  },

  // 司机姓名拼音码配置
  driverName: {
    url: '/api/blade-driver/driver/searchCode',
    value: 'driverName',
    label: 'driverName',
    soleValue: 'driverName',
    onState: true, //姓名类单字段维护 一般支持辅助录入
  },

  // 运输单位拼音码配置(承运商)
  transitcom: {
    url: '/api/blade-transitcom/transitcom/searchCode',
    label: "transitcomName",
    value: "transitcomCode",
    soleValue: 'transitcom',
  },

  // 物资大类拼音码配置
  varClassNo: {
    url: '/api/blade-var-class/varclass/searchCode',
    value: 'varClassNo',
    label: 'varClassName',
    soleValue: 'varClassNo',
  },

  // 倒出地点拼音码配置
  outLocationNo: {
    url: '/api/blade-trans-location/trans-location/searchCode',
    value: 'transLocationNo',
    label: 'transLocationName',
    soleValue: 'outLocationNo',
  },

  // 导入地点拼音码配置
  inLocationNo: {
    url: '/api/blade-trans-location/trans-location/searchCode',
    value: 'transLocationNo',
    label: 'transLocationName',
    soleValue: 'inLocationNo',
  },

  // 车辆类型拼音码配置
  vehicleType: {
    url: '/api/blade-vehicle-type/vehicleType/searchCode',
    value: 'vehicleTypeCode',
    label: 'vehicleTypeName',
    soleValue: 'vehicleType',
  },

  // 运往地拼音码配置
  mgjDestination: {
    url: 'api/blade-mgjdestination/mgj-destination/searchCode',
    value: 'divisionId',
    label: 'divisionName',
    soleValue: 'divisionId',
  },

  // 物资
  mgjStandProduct: {
    url: 'api/blade-mgjstandproduct/mgj-stand-product/searchCode',
    value: 'productId',
    label: 'productName',
    soleValue: 'standProductId',
    customQuery: {
      varType: 0
    }
  },

  // 煤类
  mgjCustomeProduct: {
    url: 'api/blade-mgjcustomeproduct/mgj-custome-product/searchCode',
    value: 'productId',
    label: 'productName',
    soleValue: 'customeProductId',
    customQuery: {
      varType: 0
    }
  },
    // 煤类
    cargoName: {
        url: '/api/produce/vardict/select/distinct/pycode',
        value: 'varNo',
        label: 'varName',
        soleValue: 'cargoNo',
        queryStr:'cargoName'
    },
  // =========简化组件内处理 设置个默认值. 默认为blade-vardict服务下产品配套配置==========
  defaultVal: {
    url: '/api/blade-vardict/vardict/searchCode',
    value: 'varNo',
    label: 'varName',
    soleValue: 'varNo',
  }
};
